<template>
  <div class="section haze full-height">
    <div class="wrapper w-container">
      <div class="middle">
        <h5 class="green left">
          <strong>Step 3 of 3 | </strong><span><strong class="bold-text-2">Selection Confirmation</strong></span>
        </h5>
      </div>
    </div>
    <div class="wrapper checkout-container w-container">
      <div class="intro">
        <h2 class="volk">
          Your Selections
        </h2>
        <div class="divider-2 animated" />
      </div>
      <div class="wrapper">
        <div
          data-w-id="f0b9ab42-350d-a008-15da-cf72af0f21bf"
          class="pricing-v3"
        >
          <div class="pricing-v3-plans mobile-sticky">
            <div class="pricing-plan-cell no-divider" />
            <div class="pricing-plan-cell">
              <h5 class="pricing-v3-plan-mobile">
                Plan
              </h5>
            </div>
            <div class="pricing-plan-cell">
              <h5 class="pricing-v3-plan-mobile">
                Add Ons
              </h5>
            </div>
            <div class="pricing-plan-cell" />
          </div>
          <div class="pricing-v3-plans top-selections">
            <div class="pricing-plan-cell-copy">
              <h4 class="pricing-v3-plan-name-copy first">
                Patient
              </h4>
            </div>
            <div class="pricing-plan-cell-copy">
              <h4 class="pricing-v3-plan-name-copy">
                Selected Plan
              </h4>
            </div>
            <div class="pricing-plan-cell-copy">
              <h4 class="pricing-v3-plan-name-copy">
                Add Ons
              </h4>
            </div>
            <div class="pricing-plan-cell-copy" />
          </div>
          <div
            v-for="patient in patients"
            :key="patient.id"
            class="pricing-v3-category"
          >
            <div class="pricing-v3-row">
              <div class="pricing-v3-row-header">
                <div class="text-block-5">
                  {{ patient.first_name }} {{ patient.last_name }}<br><span class="text-span-3">{{ patient.birth_date }}</span><br>
                </div>
              </div>
              <div class="pricing-v3-cells w-row">
                <div class="pricing-v3-cell w-col w-col-4 w-col-small-4 w-col-tiny-4">
                  <div class="mobile-text-block">
                    {{ patient.plan.display_name }}
                  </div>
                </div>
                <div class="pricing-v3-cell w-col w-col-4 w-col-small-4 w-col-tiny-4">
                  <div class="mobile-text-block">
                    <span
                      v-for="(addon, index) in patient.addons"
                      :key="addon.id"
                    >
                      <span>{{ addon.display_name }}</span><span v-if="index+1 < patient.addons.length"> | </span>
                    </span><br>
                  </div>
                </div>
                <div class="pricing-v3-cell w-col w-col-4 w-col-small-4 w-col-tiny-4">
                  <a
                    href="#"
                    class="button pricing-cell-button ghost w-button"
                    @click="editSelection(patient)"
                  >Edit </a><a
                    href="#"
                    class="button pricing-cell-button ghost red w-button"
                    @click="deletePatient(patient)"
                  >Delete</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="big-message">
        <div class="big-message-text">
          Would you like to add another plan member?
        </div><a
          href="#"
          class="button w-button"
          @click="addAnother"
        >+ Add Another</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Signup4Component',
  props: {
    patients: {
      type: Array,
      default: null
    }
  },
  mounted () {
    window.Webflow && window.Webflow.destroy()
    window.Webflow && window.Webflow.ready()
    window.Webflow && window.Webflow.require('ix2').init()
    document.dispatchEvent(new Event('readystatechange'))
  },
  methods: {
    editSelection (patient) {
      this.$emit('editSelection', patient)
    },
    addAnother () {
      this.$emit('addAnotherPatient')
    },
    deletePatient (patient) {
      this.$emit('deletePatient', patient)
    }
  }
}
</script>
